import Button from '@/components/UiElements/Button'

interface ModalCloseButtonProps {
    onClick: () => void
}

const ModalCloseButton = ({onClick}: ModalCloseButtonProps) => (
    <Button
        className="font-icon-solid w-[37px] h-[37px] overflow-hidden items-center justify-center flex text-[18px] p-0 !text-primary-600 hover:!text-gray-900 focus:!text-gray-900 active:!text-primary-800"
        type="link"
        onClick={onClick}
    >
        
    </Button>
)

export default ModalCloseButton
